module.exports = __webpack_public_path__ + "img/p1.828dbb83.jpg";